import { createContext, PropsWithChildren, useContext, useLayoutEffect, useState } from "react";

export type AccountChatUser = { userId: number; sessionId: string; identifierHash?: string | null };
export type InfoHappChatUser = { userId: number; identifierHash: string };

const LandingReadyContext = createContext({
  ready: false, setReady: (_ready: boolean) => {},
  chatReady: false, setChatReady: (_ready: boolean) => {},
  chatOpen: false, setChatOpen: (_open: boolean) => {},
  unread: false, setUnread: (_unread: boolean) => {},
  accountUser: null as AccountChatUser | null,
  setAccountUser: (_user: AccountChatUser | null) => {},
  infoHappUser: null as InfoHappChatUser | null,
  setInfoHappUser: (_user: InfoHappChatUser | null) => {},
});

export const LandingReadyProvider = ({ children }: PropsWithChildren) => {
  const [ready, setReady] = useState(false);
  const [chatReady, setChatReady] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [unread, setUnread] = useState(false);
  const [accountUser, setAccountUser] = useState<AccountChatUser | null>(null);
  const [infoHappUser, setInfoHappUser] = useState<InfoHappChatUser | null>(null);
  return <LandingReadyContext.Provider value={{ ready, setReady, chatReady, setChatReady, chatOpen, setChatOpen, unread, setUnread, accountUser, setAccountUser, infoHappUser, setInfoHappUser }}>{children}</LandingReadyContext.Provider>;
};

export const useLandingReady = () => useContext(LandingReadyContext).ready;
export const useLandingChat = () => useContext(LandingReadyContext);

// Mounted inside Suspense only after the landing has committed to the DOM.
export const LandingReady = () => {
  const { setReady } = useContext(LandingReadyContext);
  useLayoutEffect(() => {
    setReady(true);
    return () => setReady(false);
  }, [setReady]);
  return null;
};
